import React from 'react';
import { Box, Button, Card, Grid, Stack, Typography, TextField } from '@mui/material';
import Iconify from '../../../components/Iconify';

const BannerCard = ({ bannerr, onDelete, onDisable, onEnable, edit, handleSttChange }) => {
  const { _id, banner, status, stt } = bannerr;
  return (
    <Card sx={{ mt: '8px' }}>
      <Grid container>
        <Grid item sm={5}>
          <img
            alt="logo"
            style={{ width: '100%', height: '350px', objectFit: 'cover' }}
            src={`${process.env.REACT_APP_IMAGE}${banner}`}
          />
        </Grid>
        <Grid item sm={7} p={3}>
          <Stack direction={'column'}>
            <Stack direction="row" sx={{ mt: 1 }} justifyContent="space-between">
              <Typography variant="subtitle2">Trạng thái: </Typography>
              <Stack direction="row" spacing={2}>
                <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    background: status === 'Inactive' ? '#ff9a001c' : '#1aff0012',
                    color: status === 'Inactive' ? '#f39c12' : '#42f233',
                    p: '2px',
                    borderRadius: '3px',
                  }}
                >
                  <Iconify icon={'akar-icons:check-box'} sx={{ width: 16, height: 16, mr: 0.5 }} />
                  <Typography fontWeight={'bold'} variant="caption">
                    {status}
                  </Typography>
                </Box>
              </Stack>
            </Stack>

            {!edit ? (
              <Stack sx={{ mt: 1 }} direction="row" justifyContent="space-between">
                <Stack direction="row" spacing={1}>
                  <Button variant="outlined" color="error" onClick={() => onDelete(_id)}>
                    Xóa banner
                  </Button>
                  {status === 'Inactive' ? (
                    <Button variant="outlined" onClick={() => onEnable(_id)}>
                      Kích hoạt
                    </Button>
                  ) : (
                    <Button variant="outlined" color="warning" onClick={() => onDisable(_id)}>
                      Ngừng hoạt động
                    </Button>
                  )}
                </Stack>
              </Stack>
            ) : (
              <TextField
                sx={{ mt: 2 }}
                label="STT"
                id="outlined-size-small"
                value={stt}
                onChange={(e) => handleSttChange(_id, e.target.value)}
                size="small"
              />
            )}
          </Stack>
        </Grid>
      </Grid>
    </Card>
  );
};

export default BannerCard;
